// extracted by mini-css-extract-plugin
module.exports = {"Freeze":"Puzzling_Freeze__3c3vN","SeatsWrapper":"Puzzling_SeatsWrapper__1ecCs","Frame":"Puzzling_Frame__Ap3ET"};